import { TabList } from '@simplywallst/ui-core';
import type { ReactNode } from 'react';
import { Badge } from '@simplywallst/ui-core/next';
import { NarrativeTab } from './NarrativeTab';
import { getPathSafe } from '@/router/utils';
import {
  ROUTE_NARRATIVE_COMMUNITY_DETAIL,
  ROUTE_NARRATIVE_COMMUNITY_DETAIL_UPDATES,
} from '@/constants/routes';
import { usePathname } from '@/hooks/location/usePathname';
import { useParams } from '@/hooks/location/useParams';

type TabValue = 'narrative' | 'updates';

type Props = {
  updateCount: number;
  children: (tab: TabValue) => ReactNode;
};

export const NarrativeViewTabs = ({ updateCount, children }: Props) => {
  const pathname = usePathname();

  const { companyname, country, exchange_ticker, industry, slug } =
    useParams<Record<string, string | undefined>>();

  const isUpdatesTabSelected = pathname.includes('/updates');

  return (
    <div>
      <TabList className="mb-x1 grid grid-cols-[max-content_max-content] gap-x1 border-0 border-b border-solid border-b-subtle">
        <NarrativeTab
          href={
            getPathSafe({
              type: ROUTE_NARRATIVE_COMMUNITY_DETAIL,
              payload: {
                country,
                industry,
                exchange_ticker,
                companyname,
                slug,
              },
            }) ?? pathname
          }
          isSelected={!isUpdatesTabSelected}
        >
          Narrative
        </NarrativeTab>
        <NarrativeTab
          isSelected={isUpdatesTabSelected}
          isDisabled={updateCount === 0}
          href={
            getPathSafe({
              type: ROUTE_NARRATIVE_COMMUNITY_DETAIL_UPDATES,
              payload: {
                country,
                industry,
                exchange_ticker,
                companyname,
                slug,
              },
            }) ?? pathname
          }
        >
          <div className="flex items-center gap-x1">
            Updates
            <Badge tone="default" variant="solid">
              {updateCount}
            </Badge>
          </div>
        </NarrativeTab>
      </TabList>
      <section>
        {children(isUpdatesTabSelected ? 'updates' : 'narrative')}
      </section>
    </div>
  );
};
